import { Reveal, RevealShot } from "./Reveal";
import { PlatformDiagram } from "./pitch";
import "./landing-top.css";

/** The opening section of /the-problem-with-rostering: "Who we are" with the platform diagram. */
export function PitchOpening() {
  return (
    <div id="return" className="rj-product-section">
      <section className="rj-product" aria-labelledby="product-title">
        <div id="start" className="rj-product-copy">
          <h2 id="product-title" className="pt-landing-title">
            Who we are
          </h2>
          <Reveal as="p" className="rj-product-description" delay={0.3}>
            We automate rostering for shift teams whose work cannot stop.
          </Reveal>
        </div>
        <figure className="rj-product-diagram">
          <RevealShot delay={0.2}>
            <PlatformDiagram />
          </RevealShot>
        </figure>
      </section>
    </div>
  );
}
